import { Component, OnInit, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { ApiDocsFacade } from './api-docs.facade';
import { AdvisorWidgetData } from '../../../../shared/advisor-widget/domain/model/advisor-widget.model';

@Component({
    selector: 'ifbp-api-docs',
    templateUrl: './api-docs.component.html',
    styleUrls: ['./api-docs.component.scss'],
    standalone: false
})
export class ApiDocsComponent implements OnInit, AfterViewInit, OnDestroy {
  apiDocsJson: string;
  advisorWidgetData: AdvisorWidgetData;
  currentTab:  'getting-started' | 'authentication' | 'reference' | 'test-scenarios' = 'getting-started';
  private styleElement: HTMLLinkElement | null = null;


  constructor(
    private elementRef: ElementRef,
    private apiDocsFacade: ApiDocsFacade
  ) { }

  ngOnInit(): void {
    this.relateStoplightCss();
    this.setDataTestSecurityStyles();
    this.apiDocsFacade.getDocsJson().subscribe(data => {
      this.apiDocsJson = data;
    });

    this.apiDocsFacade.getAdvisorData$().subscribe(data => {
      this.advisorWidgetData = data;
    });
  }

  ngAfterViewInit(): void {
    this.observeElementsApi();
  }

  setTab(tab: 'getting-started' | 'authentication' | 'reference' | 'test-scenarios'): void {
    this.currentTab = tab;
  }

  private observeElementsApi(): void {
    const observer = new MutationObserver(() => {
      const elementsApi = this.elementRef.nativeElement.querySelector('elements-api');
      if (elementsApi && elementsApi.shadowRoot) {
        const securityEl = elementsApi.shadowRoot.querySelector('[data-test="security"]');
        if (securityEl) {
          securityEl.style.display = 'none';
          observer.disconnect();
        }
      }
    });
    observer.observe(this.elementRef.nativeElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 5000);
  }

  private setDataTestSecurityStyles(): void {
    const style = document.createElement('style');
    style.textContent = `
      [data-test="security"], [data-test="security-row"] {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  private relateStoplightCss(): void {
    const linkElement = document.createElement('link') as HTMLLinkElement;
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('href', 'assets/styles/stoplight.min.css');
    document.head.appendChild(linkElement);
    this.styleElement = linkElement;
  }

  private removeRelatedStoplightCss(): void {
    if (this.styleElement) {
      document.head.removeChild(this.styleElement);
      this.styleElement = null;
    }
  }

  ngOnDestroy(): void {
    this.removeRelatedStoplightCss();
  }
}
